export const SUPPLIER_PLATFORM_TYPE = 'supplier_platform';
export const ELECTRONIC_INVOICES_TYPE = 'electronic_invoices';
